import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AccessDenied from './components/AccessDenied';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication status on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch('/api/auth.php?action=check', {
        credentials: 'include'
      });
      const data = await response.json();
      
      if (data.logged_in && data.user) {
        setUser(data.user);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontSize: '18px',
        color: '#718096'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Router basename={process.env.PUBLIC_URL || '/webScraper'}>
      <Routes>
        <Route 
          path="/login" 
          element={user ? <Navigate to="/" /> : <Login />} 
        />
        <Route 
          path="/access-denied" 
          element={<AccessDenied />} 
        />
        <Route 
          path="/" 
          element={<HomeHandler user={user} onLogout={handleLogout} />} 
        />
      </Routes>
    </Router>
  );
}

// Helper component to handle auth redirects
function HomeHandler({ user, onLogout }) {
  const [searchParams] = useSearchParams();
  const authStatus = searchParams.get('auth');

  // If user was denied access, show access denied page
  if (authStatus === 'denied') {
    return <Navigate to="/access-denied" replace />;
  }

  // Normal auth flow
  if (user) {
    return <Dashboard user={user} onLogout={onLogout} />;
  } else {
    return <Navigate to="/login" />;
  }
}

export default App;
